import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgArrowRight = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", { d: "M15.1309 19.7577C14.7403 20.1483 14.1072 20.1483 13.7166 19.7577C13.3261 19.3672 13.3261 18.734 13.7166 18.3435L19.0623 12.9979L1.47649 12.9979C0.924204 12.9979 0.476488 12.5502 0.476488 11.9979C0.476488 11.4456 0.924204 10.9979 1.47649 10.9979L19.0621 10.9979L13.7166 5.65242C13.3261 5.2619 13.3261 4.62873 13.7166 4.23821C14.1072 3.84768 14.7403 3.84768 15.1309 4.23821L22.1729 11.2802C22.1801 11.2872 22.1872 11.2943 22.1942 11.3015L22.8906 11.998L15.1309 19.7577Z" })]
});
const ForwardRef = forwardRef(SvgArrowRight);
export { ForwardRef as ReactComponent };
